import React, {useEffect, useState} from 'react';
import {message} from 'antd';
import {Button, Col, Input, Layout, Row, Select, Space, Table, TimePicker, Checkbox} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'
import ProPortalHeader from "../../../componets/ProPortalHeader";
import ProfileRow from "../../../componets/ProfileRow";
import Navigator from "../../../componets/Navigator";
import Img from "./Static Textura with Start Screen.png"
import {get_api} from "../../../serverTemp";
import {useLocation, useNavigate} from "react-router-dom";
import {Tag} from 'antd';
import {ReactComponent as RepeatIcon} from './Repeat Once.svg'
import {ShuffleIcon} from "../../Icons";
import backButton from './img/Back button.svg';

const Hardware = (props) => {
    const {state} = useLocation();
    const {deviceData} = state
    const [schedule, setSchedule] = useState([])
    const [deviceName, setDeviceName] = useState(deviceData.name)
    const [infoChanged, setInfoChanged] = useState(false)
    const [isRepeatButtonActive, setIsRepeatButtonActive] = useState(false)
    const [isShuffleButtonActive, setIsShuffleButtonActive] = useState(false)

    const navigate = useNavigate()
    // 0:Schedule 1:Setting 2:Control
    const [cur, setCur] = useState(0)
    const [newSchedule, setNewSchedule] = useState({
        "name": deviceName,
        "start_date": null,
        "end_date": null,
        "days": [],
        "start_time": "",
        "end_time": ""
    })
    const [newScheduleOpen, setNewScheduleOpen] = useState(false)
    useEffect(() => {
        get_api(`/textura/schedules?textura_id=${deviceData.id}`).then(res => {
            setSchedule(res.data)
        })
    }, [])
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const columns = [
        {
            title: 'Textura Name',
            // dataIndex: 'name',
            key: 'name',
            render: (_, record) => (
                <span>
                {deviceData.name}
            </span>
            )
        },
        {
            title: 'Start time',
            dataIndex: 'start_time',
            key: 'start',
        },
        {
            title: 'End time',
            key: 'end',
            dataIndex: 'end_time',
        },
        {
            title: <span style={{
                display: 'flex',
                // justifyContent: 'center',
            }}>Day of the week</span>,
            dataIndex: 'days',
            key: 'week',
            render: (days, record) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, idx) => {
                        return (
                            <span style={days.includes(idx) ? {
                                background: '#D9D9D9',
                                borderRadius: '50%',
                                width: '20px',
                                textAlign: 'center'
                            } : {}} key={idx}>
                                {d}
                            </span>
                        );
                    })}
                </div>
            )
        },
        {
            title: <span style={{
                display: 'flex',
                justifyContent: 'center',
            }}>Remove</span>,
            key: 'remove',
            render: (_, record) => (
                <Space size="middle" style={{
                    display: 'flex',
                    justifyContent: 'center',
                }}
                       onClick={() => {
                           message.success('Deleted a schedule successfully!')
                       }}
                >
                    <svg
                        style={{cursor: "pointer"}} xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                        viewBox="0 0 25 25" fill="none">
                        <path
                            d="M21.876 6.22982C18.4072 5.88607 14.9176 5.70898 11.4385 5.70898C9.37598 5.70898 7.31348 5.81315 5.25098 6.02148L3.12598 6.22982"
                            stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                            d="M8.85059 5.17578L9.07975 3.8112C9.24642 2.82161 9.37142 2.08203 11.1318 2.08203H13.861C15.6214 2.08203 15.7568 2.86328 15.9131 3.82161L16.1423 5.17578"
                            stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path
                            d="M19.6331 9.53125L18.9561 20.0208C18.8415 21.6562 18.7477 22.9271 15.8415 22.9271H9.15397C6.24772 22.9271 6.15397 21.6562 6.03939 20.0208L5.3623 9.53125"
                            stroke="#AAAAAA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.7607 17.1914H14.2295" stroke="#AAAAAA" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M9.89062 13.0293H15.099" stroke="#AAAAAA" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </Space>
            ),
        },
    ];
    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <Layout>
            <Content style={{paddingTop: '0.625rem'}}>
                <ProPortalHeader/>
                <ProfileRow/>
                <Row>
                    <Layout>
                        <Navigator/>
                        <Layout>
                            <Row style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '50px',
                                marginLeft: '20px'
                            }}>
                                <img src={backButton} alt="BackButton" className='BackButtonIcon'
                                     style={{marginRight: '60px', cursor: "pointer"}} onClick={handleBackClick}/>
                                <p className='hard-title' style={{margin: 0}}>Hardware detail</p>
                            </Row>
                            <Row justify={"center"}>
                                <Col span={8} lg={8}>
                                    <div className={'hard-img-div'}>
                                        <img src={Img} className={'hard-img'} alt={'img'}/>
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <Row justify={"center"} className={'hard-row'}>
                                        <Input className={'hard-input'}
                                               placeholder="Name"
                                               onChange={(e) => {
                                                   const userInput = e.target.value;
                                                   setDeviceName(userInput);
                                                   setInfoChanged(true)
                                               }}
                                               defaultValue={deviceData.name}/>
                                        <Input className={'hard-input'} placeholder="Subscription"
                                               disabled={true}
                                               defaultValue={
                                                   localStorage.getItem('subscription')
                                               }/>
                                    </Row>
                                    <Row justify={"center"} className={'hard-row'}>
                                        <Input className={'hard-input'} placeholder="SN"
                                               defaultValue={deviceData.sn}
                                               disabled={true}
                                        />
                                        <Input className={'hard-input'} placeholder="Portrait"
                                               disabled={true}
                                               defaultValue={deviceData.angle === 90 || deviceData.angle === 270 ?
                                                   'Portrait' : 'Landscape'}/>
                                    </Row>
                                    <Row justify={"center"} className={'hard-row'}>
                                        <Input.Group className={'hard-input'} placeholder="Group"
                                                     defaultValue={deviceData.group}>
                                            <Select
                                                style={{
                                                    width: '100%',
                                                }}
                                                defaultValue="England"
                                                onChange={() => {
                                                    setInfoChanged(true)
                                                }}
                                            >
                                                <Select.Option value="England">England</Select.Option>
                                                <Select.Option value="London">London</Select.Option>
                                                <Select.Option value="B">Birmingham</Select.Option>
                                            </Select>
                                        </Input.Group>
                                        <Button className={'hard-group-btn'}
                                                onClick={() => {
                                                    window.location.href = '/proportal/ProportalGroup'
                                                }}
                                        >
                                            Manage Groups
                                        </Button>
                                    </Row>
                                    <Row className={'hard-row'} style={{margin: '2rem 0 0 -42.3vw'}}>
                                        <Button className={'hard-btn'}
                                                onClick={_ => setCur(0)}>
                                            Schedule
                                        </Button>
                                        <Button className={'hard-btn'}
                                                onClick={_ => setCur(1)}
                                                style={{margin: '0 0 0 -3rem'}}>
                                            Setting
                                        </Button>
                                        <Button className={'hard-btn'}
                                                onClick={_ => setCur(2)}
                                                style={{margin: '0 0 0 -3rem'}}>
                                            Control
                                        </Button>
                                    </Row>
                                    {cur === 0 && <><Row>
                                        <p className={'hard-cur-sch'}>
                                            Current schedule
                                        </p>
                                    </Row>
                                        <Table style={{
                                            margin: '2rem 0rem 0 -2rem',
                                            borderRadius: '8px',
                                            border: '2px solid #FFF'
                                        }}
                                               columns={columns}
                                               dataSource={schedule}
                                               pagination={false}
                                        /></>}
                                    {cur === 1 && <div style={{margin: '0 0 0 -1rem'}}>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '2rem 0 0 0'}}
                                        >
                                            <p>Orientation</p>
                                        </Row>
                                        <Checkbox.Group
                                            style={{
                                                width: '100%',
                                                margin: '0.2rem 0 1rem 0'
                                            }}
                                            // onChange={onChange}
                                        >
                                            <Row justify={'start'}>
                                                <Col span={2}>
                                                    <span className={'hd-settings-txt'}>Angle</span>
                                                </Col>
                                                <Col span={2}>
                                                    <Checkbox value="A" onChange={() => {
                                                        setInfoChanged(true)
                                                    }}>
                                                        0°
                                                    </Checkbox>
                                                </Col>
                                                <Col span={2}>
                                                    <Checkbox value="B" onChange={() => {
                                                        setInfoChanged(true)
                                                    }}>
                                                        90°
                                                    </Checkbox>
                                                </Col>
                                                <Col span={2}>
                                                    <Checkbox value="C" onChange={() => {
                                                        setInfoChanged(true)
                                                    }}>
                                                        180°
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                        </Checkbox.Group>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '1rem 0 0 0'}}
                                        >
                                            <p>Volume</p>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-ip'}>
                                            <Input defaultValue={50} onChange={() => {
                                                setInfoChanged(true)
                                            }}/>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '1rem 0 0 0'}}>
                                            <p>Brightness</p>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-ip'}>
                                            <Input defaultValue={50} onChange={() => {
                                                setInfoChanged(true)
                                            }}/>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-txt'}
                                             style={{margin: '1rem 0 0 0', width: '100%'}}>
                                            <p>Image duration(seconds)</p>
                                        </Row>
                                        <Row justify={'start'} className={'hd-settings-ip'}>
                                            <Input defaultValue={'15'} onChange={() => {
                                                setInfoChanged(true)
                                            }}/>
                                        </Row>
                                    </div>}
                                    {cur === 2 && <div>
                                        <div style={{
                                            margin: '2rem 0 0 -2rem', width: '20vw',
                                            borderRadius: '6px',
                                            border: '0px solid #E2E2E2', // Or simply 'none' if you don't need a border
                                            background: '#F4F4F4',
                                            boxShadow: '-2px -3px 10.4px -5px rgba(0, 0, 0, 0.18) inset'
                                        }}>
                                            <Row justify={'start'}>
                                                <p className={'zh-ml-schedule-modal-h'}>Playback Options</p>
                                            </Row>
                                            <Row justify={"start"} style={{margin: '1rem 0 0 0'}}>
                                                <p className={'zh-ml-schedule-modal-p'}>
                                                    When you use this particular function you
                                                    will need to assess your hardware
                                                </p>
                                            </Row>
                                            <Row justify={'start'} style={{margin: '3rem 0 2rem 0'}}>
                                                <Col span={12}>
                                                    <Row justify={'center'}>
                                                        <div className={'hd-control-div'} style={{
                                                            height: '2.6vw',
                                                            width: '6.2vw',
                                                            // marginLeft: '6vw'
                                                        }}>
                                                            <button className={'hd-control-btn'}
                                                                    style={{
                                                                        margin: '0 0 0 0.5rem',
                                                                        backgroundColor: isRepeatButtonActive ? '#A06174' : '#0E487A',
                                                                        width: '2vw',
                                                                        height: '2vw'
                                                                    }}
                                                                    onClick={_ => {
                                                                        setIsRepeatButtonActive(!isRepeatButtonActive)
                                                                        setIsShuffleButtonActive(false)
                                                                    }}
                                                            >
                                                                <RepeatIcon/>
                                                            </button>
                                                            <p className={'hd-control-p'} style={{
                                                                color: isRepeatButtonActive ? '#000' : '#D9D9D9',
                                                                // marginLeft: '1vw'
                                                            }}>
                                                                Repeat Single mode is on
                                                            </p>
                                                        </div>
                                                    </Row>
                                                    <Row justify={'center'} style={{marginTop: '1vh'}}>
                                                        <p>Repeat Single</p>
                                                    </Row>
                                                </Col>
                                                <Col span={12}>
                                                    <Row justify={'center'}>
                                                        <div className={'hd-control-div'} style={{
                                                            height: '2.6vw',
                                                            width: '6.2vw',
                                                        }}>
                                                            <button className={'hd-control-btn'}
                                                                    style={{
                                                                        margin: '0 0 0 0.5rem',
                                                                        backgroundColor: isShuffleButtonActive ? '#A06174' : '#0E487A',
                                                                        width: '2vw',
                                                                        height: '2vw'
                                                                    }}
                                                                    onClick={_ => {
                                                                        setIsShuffleButtonActive(!isShuffleButtonActive)
                                                                        setIsRepeatButtonActive(false)
                                                                    }}>
                                                                <ShuffleIcon/>
                                                            </button>
                                                            <p className={'hd-control-p'} style={{
                                                                color: isShuffleButtonActive ? '#000' : '#D9D9D9',
                                                            }}>
                                                                Shuffle mode is on
                                                            </p>
                                                        </div>
                                                    </Row>
                                                    <Row justify={'center'}
                                                         style={{marginTop: '1vh'}}>
                                                        <p>Shuffle</p>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                        <Row justify={'start'}>
                                            <Button className={'hard-btn'}
                                                    style={{
                                                        width: '8vw',
                                                        marginLeft: '-1.6vw'
                                                    }}
                                                    onClick={() => {
                                                        navigate('/proportal/images', {
                                                            state: {
                                                                textura_ids: [deviceData.id],
                                                                title: 'Select artwork to the current playlist',
                                                                filter: -1,
                                                                checkMode: true
                                                            }
                                                        })
                                                    }}
                                            >
                                                Add Artwork
                                            </Button>
                                            <Button className={'hard-btn'}
                                                    style={{
                                                        width: '9vw',
                                                        marginLeft: '2vw'
                                                    }}
                                                    onClick={() => {
                                                        navigate('/proportal/images', {
                                                            state: {
                                                                textura_ids: [deviceData.id],
                                                                title: 'Please Remove Artworks',
                                                                filter: -1,
                                                                checkMode: true,
                                                                removeMode: true,
                                                            }
                                                        })
                                                    }}
                                            >
                                                Remove Artwork
                                            </Button>
                                        </Row>
                                    </div>}

                                </Col>
                            </Row>
                            <Row>
                                <Button className={'hard-btn'}
                                        style={{
                                            width: '199.685px',
                                            margin: '2rem 0 2rem 6rem',
                                            display: cur === 0 ? 'flex' : 'none'
                                        }}
                                        onClick={() => {
                                            setNewSchedule({
                                                "name": deviceData.name,
                                                "start_date": null,
                                                "end_date": null,
                                                "days": [],
                                                "start_time": "",
                                                "end_time": ""
                                            })
                                            setNewScheduleOpen(true)
                                            setInfoChanged(true)
                                        }}
                                >
                                    Add New Schedule
                                </Button>
                            </Row>
                            <Row className={'hard-week-above-row'} style={{
                                display: newScheduleOpen && cur === 0 ? 'flex' : 'none',
                            }}>
                                <span className={'hard-st-time-txt'}>Start time:</span>
                                <span className={'hard-end-time-txt'}>End time:</span>
                            </Row>
                            <Row className={'hard-week-row'} style={{
                                display: newScheduleOpen && cur === 0 ? 'flex' : 'none',
                            }}>
                                <TimePicker className={'hard-input-week'}
                                            onChange={(time, timeString) => {
                                                setNewSchedule(prevSchedule => {
                                                    return {...prevSchedule, start_time: timeString};
                                                })
                                            }}
                                            format="HH:mm"
                                />
                                <TimePicker className={'hard-input-week'}
                                            onChange={(time, timeString) => {
                                                setNewSchedule(prevSchedule => {
                                                    return {...prevSchedule, end_time: timeString};
                                                });
                                            }}
                                            format="HH:mm"
                                />
                                {daysOfWeek.map((day, index) => (
                                    <div
                                        key={index}
                                        className={'hard-week-btn'}
                                        style={{backgroundColor: newSchedule.days.includes(index) ? '#0E487A' : '#D9D9D9'}}
                                        onClick={() => {
                                            setNewSchedule(prevSchedule => {
                                                const newDays = prevSchedule.days.includes(index)
                                                    ? prevSchedule.days.filter(d => d !== index)
                                                    : [...prevSchedule.days, index];
                                                return {...prevSchedule, days: newDays};
                                            });
                                        }}
                                    >
                                        {day}
                                    </div>
                                ))}
                            </Row>
                            <Row className={'hard-final-row'}
                                 style={{
                                     marginTop: cur === 0 ? '0' : '4rem',
                                     display: infoChanged && cur !== 2 ? 'flex' : 'none'
                                 }}>
                                <Button className={'hard-week-final-btn'}
                                        onClick={() => {
                                            message.success('Saved successfully!')
                                        }}
                                >
                                    Save
                                </Button>
                                <Button className={'hard-week-final-btn'}
                                        onClick={() => {
                                            window.location.href = '/proportal/dashboard'
                                        }}
                                >
                                    Close
                                </Button>
                            </Row>
                        </Layout>
                    </Layout>
                </Row>
            </Content>
        </Layout>
    )
}

export default Hardware;
